import { render } from "./AddInvest.vue?vue&type=template&id=7dee7477&scoped=true"
import script from "./AddInvest.vue?vue&type=script&lang=js"
export * from "./AddInvest.vue?vue&type=script&lang=js"

import "./AddInvest.vue?vue&type=style&index=0&id=7dee7477&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dee7477"]])

export default __exports__